import { connect, MapStateToProps } from 'react-redux'
import { Props } from './ForesightedBuildabilityModal'
import foresightedBuildabilityItemsSelector from '../../redux/selectors/configuration/foresightedBuildabilityItemsSelector'
import configurationRequestIsPendingSelector from '../../redux/selectors/pending-request/configurationRequestIsPendingSelector'
import foresightedBuildabilityIsResolvableSelector from '../../redux/selectors/configuration/foresightedBuildabilityIsResolvableSelector'
import conflictTotalSelector from '../../redux/selectors/configuration/conflictTotalSelector'
import { adoptConflictSolution, cancelConflictSolution, stepBackConflictSolution } from '../../redux/actions/app/conflictSolution.actions'
import { openInfoModal } from '../../redux/actions/app/infoModal.actions'
import { deselectEquipment, selectEquipment } from '../../redux/actions/app/equipmentGroups.actions'
import foresightedBuildabilityCheckIsDisabledSelector from '../../redux/selectors/feature-scope/foresightedBuildabilityCheckIsDisabledSelector'
import foresightedBuildabilityIsCancelableSelector from '../../redux/selectors/configuration/foresightedBuildabilityIsCancelableSelector'
import foresightedBuildabilityIsStepBackSelector from '../../redux/selectors/configuration/foresightedBuildabilityIsStepBackSelector'
import foresightedBuildabilityTriggerItemSelector from '../../redux/selectors/configuration/foresightedBuildabilityTriggerItemSelector'
import currentBuildabilityTypeSelector from '../../redux/selectors/buildability/currentBuildabilityTypeSelector'
import hideBuildabilityConflictLabelSelector
    from '../../redux/selectors/view-properties/hideBuildabilityConflictLabelSelector'
type StateProps = Pick<Props, 'conflictSteps' | 'isLoading' | 'isResolvable' | 'isCancelable' | 'isStepBack' | 'total' | 'isDisabled' | 'trigger' | 'buildabilityType' | 'hideBuildabilityConflictLabel'>

const mapStateToProps: MapStateToProps<StateProps, {}> = (state) => ({
    conflictSteps: foresightedBuildabilityItemsSelector(state),
    total: conflictTotalSelector(state),
    isLoading: configurationRequestIsPendingSelector(state),
    isResolvable: foresightedBuildabilityIsResolvableSelector(state),
    isCancelable: foresightedBuildabilityIsCancelableSelector(state),
    isDisabled: foresightedBuildabilityCheckIsDisabledSelector(state),
    isStepBack: foresightedBuildabilityIsStepBackSelector(state),
    trigger: foresightedBuildabilityTriggerItemSelector(state),
    buildabilityType: currentBuildabilityTypeSelector(state),
    hideBuildabilityConflictLabel: hideBuildabilityConflictLabelSelector(state),
})

type DispatchProps = Pick<Props, 'adoptConflictSolution' | 'cancelConflictSolution' | 'stepBackConflictSolution' | 'selectEquipment' | 'deselectEquipment' | 'openInfoModal'>

const mapDispatchToProps: DispatchProps = {
    adoptConflictSolution,
    cancelConflictSolution,
    stepBackConflictSolution,
    selectEquipment,
    deselectEquipment,
    openInfoModal,
}

export default connect(mapStateToProps, mapDispatchToProps)
